import { TextBox, TextBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { getPercentOfApprovedAmount } from './functions/getPercentOfApprovedAmount';

/** Read-only: Broker Addl. as a percent of Apprvd Loan Amt. */
export const BrokerAdditionalPercentField = () => {
    const brokerAdditional = useStandardLoanStore((state) => state.loan.brokerAdditional);
    const commitment = useStandardLoanStore((state) => state.loan.commitment);

    return (
        <TextBox
            id='loanBrokerAdditionalPercent'
            value={getPercentOfApprovedAmount(brokerAdditional, commitment)}
            onChange={() => undefined}
            label='Broker Addl. %'
            disabled={true}
            width='100%'
            height='36px'
            layoutStyle={TextBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
